module.exports = __webpack_public_path__ + "img/18_66.1959d7dd.png";